/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Mojo QA environment overrides.
 *
 * @author Mohamed yasar arabath M
 */

const SSI_CLIENT_ID = 'I3l3CiMiPkq8LpGSK9IMRcHBJlSQKhYH';

const mojoQa = {
  ENVIRONMENT: 'qa',
  PARTNER_ENV: 'qa',
  CLIENT_ID: 'jbxnqvJw6NJEMzJLBQbMSVWpgrZUUC0g',
  SSI_CLIENT_ID,
  TENANT_KEY_ETEXT: '28da38d3-5160-4ce2-b90b-597a5fefbd40',
  TENANT_KEY_ETEXT_PDF: '28da38d3-5160-4ce2-b90b-597a5fefbd40',
  BERLIN: {
    STREAM_BASE_URL: 'https://plus-qa.pearson.com/ber-api/api',
    TENANT_ID: '7408ccc0-86ac-40e5-9d6d-9e1eae93900c',
    TENANT_KEY: 'f917690b-f60f-4f77-93c8-2ef8eacf5d3e'
  },
  PREP_FLASH_CARDS_TENANT_ID: '30258aed-46bb-4ec5-909e-ecea2431772b',
  PREP_FLASH_CARDS_TENANT_KEY: '297a5917-24fa-43fe-a27b-426126bd7cf4',
  GTM_AUTH: 'neDCHn1snhB9TDBHGb9iJA',
  GTM_PREVIEW: 'env-4',
  CSG_API_BASE_URL: 'https://content-service-qa.stg-prsn.com/csg/api/v3',
  PAPER_API_BASE_URL: 'https://paperapi-qa.stg-openclass.com/nextext-api/api/platforms/bookshelf',
  PRISM_API_BASE_URL: 'https://prism-qa.pearsoned.com/api',
  SPECTRUM_API_BASE_URL: 'https://spectrum-qa.pearsoned.com/api',
  SPECTRUM_API_V4_BASE_URL: 'https://spectrum-stg.pearsoned.com/api/v4', // TODO: Need to check with Spectrum team for notescopy support
  STPAPER_API_BASE_URL: 'https://stpaperapiqa.stg-prsn.com/etext/v2',
  MARIN_API_BASE_URL: 'https://plus-qa.pearson.com/marin/api/1.0',
  MARIN_API_BASE_URL_V2: 'https://plus-qa.pearson.com/marin/api/2.0',
  MARIN_API_BASE_URL_V3: 'https://plus-qa.pearson.com/marin/api/3.0',
  ETEXT_API_BASE_URL: 'https://etext-qa-stg.pearson.com/api/nextext-api/v1/api',
  IDC_API_BASE_URL: 'https://etext-instructor-qa.pearson.com/idc-api/',
  SPECTRUM_X_TENANTKEY: '9acc0488-6a42-4c54-8d7a-edbac1716e73',
  PSEUDO_LOCALE_CODE: null,
  ZEPPELIN_URL: 'https://zeppelin-qa.dev-openclass.com/products',
  CONSOLE_URL: 'https://console-qa.pearsoned.com',
  TENANT_ID_ETEXT: '2b4af3fc-97b4-41a3-af7e-bc9354d35fed',
  PRODUCT_TOKEN: '1',
  PLUS_URL: 'https://plus-qa.pearson.com',
  ETEXT_URL: 'https://etext-ise-qa.pearson.com',
  IES_BASE_URL: 'https://login-qa.pearson.com/v1/piapi-test'
};

module.exports = mojoQa;
